/**
 * DAVMAN AI INTEGRATION
 * Este archivo es parte de la integración personalizada de IA para Davman Persa.
 * NO es parte del código original de Chatwoot.
 *
 * Tipos de mutations para el store de Davman AI
 */

export const SET_SUGGESTION = 'SET_SUGGESTION';
export const CLEAR_SUGGESTION = 'CLEAR_SUGGESTION';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_SERVICE_AVAILABLE = 'SET_SERVICE_AVAILABLE';
export const SET_LAST_HEALTH_CHECK = 'SET_LAST_HEALTH_CHECK';
